module.exports = __webpack_public_path__ + "img/bg_hover@2x.bb48543.png";